
import {TypeInt} from './../TypeDefinition'

import CodeHelpers from './CodeHelpers.js'
import ParseDeclarations from './ParseDeclarations.js'
import ParseInspections from './ParseInspections.js'
import ParseSentences from './ParseSentences.js'
import ParseType from './ParseType.js'

function ParseCallable (parser) {
    this.parser = parser
    this.scanner = parser.scanner
    this.pcode = parser.pcode
    this.stable = parser.stable
    this.SC = parser.config
    this.hintHelper = parser.hintHelper
    this.outline = parser.outline
}

ParseCallable.prototype = {
    parse () {
        if (this.hintHelper) {
            this.hintHelper.checkTokensForHints([this.SC.K_SUB_PROCESS, this.SC.K_FUNCTION])
        }
        while (this.scanner.nextIsIn([this.SC.K_SUB_PROCESS, this.SC.K_FUNCTION])) {
            if (this.scanner.nextIs(this.SC.K_SUB_PROCESS)) {
                this.parseCallable(true)
            } else {
                this.parseCallable(false)
            }
        }
    },
    parseCallable (isMethod) {
        let callableStartToken
        let callableEndToken
        let name
        let returnName
        let returnType
        let expectedToken
        let parDispl = 0
        let codeHelpers = new CodeHelpers(this.parser)
        let parseDeclarations = new ParseDeclarations(this.parser)
        let parseSentences = new ParseSentences(this.parser)
        let parseInspections = new ParseInspections(this.parser)
        let parseType = new ParseType(this.parser)

        if (isMethod) {
            callableStartToken = this.parser.expect(this.SC.K_SUB_PROCESS)
        } else {
            callableStartToken = this.parser.expect(this.SC.K_FUNCTION)
        }

        name = this.parser.expect(this.SC.IDENT)
        if (name !== false) {
            if (this.stable.hasCallable(name.lexema)) {
                this.parser.error(name, 'Ya existe un sub proceso o una función con ese nombre.')
            } else {
                if (isMethod) {
                    this.stable.addMethod(name.lexema, false, name)
                } else {
                    // Poner por ahora TypeInt y luego reemplazar
                    this.stable.addFunction(name.lexema, TypeInt(), false, name)
                }
                if (this.parser.compile) {
                    this.stable.getCallable(name.lexema).setDisplacement(this.pcode.instructionCount() + 1)
                }
            }
        }
        if (this.parser.compile) {
            // this.pcode.tag('Inicio ' + name.lexema)
            callableStartToken.procName = name.lexema
            this.pcode.start(callableStartToken)
        }
        this.parser.currentProcName = name.lexema
        this.outline[this.parser.currentProcName] = {
            variables: {},
            kind: isMethod ? 'method' : 'function'
        }

        this.stable.enterBlock()

        this.parser.expect(this.SC.OPEN_PAR)

        this.parseParameters(name.lexema, isMethod)

        this.parser.expect(this.SC.CLOSE_PAR)

        if (!isMethod) {
            expectedToken = this.parser.expect(this.SC.K_RETURN)
            if (this.hintHelper && expectedToken === false) {
                this.hintHelper.checkTokensForHints([this.SC.K_RETURN])
            }
            returnName = this.parser.expect(this.SC.IDENT)
            expectedToken = this.parser.expect(this.SC.K_AS)
            if (this.hintHelper && expectedToken === false) {
                this.hintHelper.checkTokensForHints([this.SC.K_AS], '\n', [this.SC.K_INT, this.SC.K_FLOAT, this.SC.K_CHAR, this.SC.K_BOOL])
            }
            returnType = parseType.parse()

            this.stable.getCallable(name.lexema).setType(returnType)
            if (returnName !== false) {
                if (this.stable.hasCallable(returnName.lexema)) {
                    this.parser.error(returnName, 'Ya existe un sub proceso o una función con ese nombre.')
                } else if (this.stable.hasStorage(returnName.lexema)) {
                    this.parser.error(returnName, 'Ya existe una variable o parámetro con ese nombre.')
                } else {
                    this.stable.addReturnVariable(returnName.lexema, returnType, returnName)
                    this.stable.getReturnVariable(returnName.lexema).setDisplacement(-this.stable.listParameters().length - 2)
                }
            }
        }

        if (this.parser.compile) {
            parDispl = codeHelpers.codeAllocateParams(name.lexema)
        }

        parseDeclarations.parse(parDispl + 1)

        parseSentences.parse()

        parseInspections.parse(name.lexema)

        if (isMethod) {
            callableEndToken = this.parser.expect(this.SC.K_END_SUB_PROCESS)
            if (this.hintHelper && callableEndToken === false) {
                this.hintHelper.checkTokensForHints([this.SC.K_END_SUB_PROCESS], '\n')
            }
        } else {
            callableEndToken = this.parser.expect(this.SC.K_END_FUNCTION)
            if (this.hintHelper && callableEndToken === false) {
                this.hintHelper.checkTokensForHints([this.SC.K_END_FUNCTION], '\n')
            }
        }

        if (this.parser.compile) {
            callableEndToken.procName = name.lexema
            codeHelpers.codeDeallocateVars(callableEndToken)
            this.pcode.return(callableEndToken)
        }
        this.parser.currentProcName = '_'
        this.stable.exitBlock()
    },
    parseParameters (callableName, allowByRef) {
        if (this.scanner.nextIs(this.SC.IDENT)) {
            this.parseParameter(callableName, allowByRef)

            while (this.scanner.nextIs(this.SC.COMMA)) {
                this.scanner.consume()
                this.parseParameter(callableName, allowByRef)
            }
        }
    },
    parseParameter (callableName, allowByRef) {
        let currentIdent
        let passToken
        let isArray = []
        let idents = []
        let type
        let readIdent = true
        let parseType = new ParseType(this.parser)

        while (readIdent) {
            currentIdent = this.parser.expect(this.SC.IDENT)

            if (currentIdent !== false) {
                if (this.parser.isKeyword(currentIdent.lexema)) {
                    this.parser.error(currentIdent, 'La palabra ' + currentIdent.lexema + ' es una palabra reservada del lenguaje y no puede utilizarse aquí.')
                }
                idents.push(currentIdent)
                if (this.scanner.nextIs(this.SC.INDEX_SEL_OPEN)) {
                    this.scanner.consume()
                    this.parser.expect(this.SC.INDEX_SEL_CLOSE)
                    isArray[idents.length - 1] = true
                } else {
                    isArray[idents.length - 1] = false
                }
            }

            readIdent = this.scanner.nextIs(this.SC.COMMA)
            if (readIdent) {
                this.scanner.consume()
            }
        }

        this.parser.expect(this.SC.K_AS)

        type = parseType.parse()
        type.setAsParameter()

        if (this.scanner.nextIs(this.SC.K_BY)) {
            this.scanner.consume()
            passToken = this.scanner.consume()
            if (passToken.code === this.SC.K_REFERENCE.code && allowByRef) {
                type.setAsReference()
            } else if (passToken.code === this.SC.K_REFERENCE.code && !allowByRef) {
                this.parser.error(passToken, 'Las funciones no pueden tener parámetros por referencia. Solo devuelven un único valor, que es el de retorno.')
            } else if (passToken.code !== this.SC.K_VALUE.code) {
                this.parser.error(passToken, 'Se esperaba Valor o Referencia.')
            }
        }

        for (let i in idents) {
            let identType = type.clone()
            if (isArray[i]) {
                identType.setAsArray()
            }
            if (this.stable.hasCallable(idents[i].lexema)) {
                this.parser.error(idents[i], 'No puede haber un parámetro con el mismo nombre que el de un sub proceso o función.')
            } else if (this.stable.getCallable(callableName).getExtra().hasParam(idents[i].lexema)) {
                this.parser.error(idents[i], 'Ya existe un párametro con ese nombre.')
            } else {
                // Guardar el parametro en la funcion, para que quede la info cuando se llama
                this.stable.getCallable(callableName).getExtra().addParam(idents[i].lexema, identType, idents[i])
                // Guardar como parametro para accederla desde el bloque actual
                this.stable.addParameter(idents[i].lexema, identType, idents[i])
                this.outline[callableName].variables[idents[i].lexema] = {
                    type: identType.clone(),
                    displacement: 0
                }
            }
        }
    }
}

export default ParseCallable



// WEBPACK FOOTER //
// ./src/Core/Parser/Components/ParseCallable.js